"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/authenticationService',["require", "exports", "controllers/authenticationController"], function (require, exports, authenticationController) {
    "use strict";

    var AuthenticationService = function () {
        function AuthenticationService() {
            _classCallCheck(this, AuthenticationService);
        }

        _createClass(AuthenticationService, [{
            key: "getManageInfo",
            value: function getManageInfo() {
                var generateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                return authenticationController.getManageInfo(generateState);
            }
        }, {
            key: "getUserInfo",
            value: function getUserInfo(accessToken) {
                return authenticationController.getUserInfo();
            }
        }, {
            key: "getPolicyHolderInfo",
            value: function getPolicyHolderInfo(accessToken) {
                return authenticationController.getPolicyHolderInfo(accessToken);
            }
        }, {
            key: "addExternalLogin",
            value: function addExternalLogin(accessToken) {
                return authenticationController.addExternalLogin({
                    externalAccessToken: accessToken
                });
            }
        }, {
            key: "login",
            value: function login(username, password, rememberMe) {
                var data = {
                    username: username,
                    password: password,
                    rememberMe: rememberMe
                };
                return authenticationController.login(data);
            }
        }, {
            key: "twoFactor",
            value: function twoFactor(username, code, rememberMe) {
                var data = {
                    username: username,
                    rememberMe: rememberMe,
                    code: code
                };
                return authenticationController.twoFactor(data);
            }
        }, {
            key: "recoveryCode",
            value: function recoveryCode(username, _recoveryCode, rememberMe) {
                var data = {
                    username: username,
                    rememberMe: rememberMe,
                    recoveryCode: _recoveryCode
                };
                return authenticationController.recoveryCode(data);
            }
        }, {
            key: "logout",
            value: function logout() {
                return authenticationController.logout();
            }
        }, {
            key: "changePassword",
            value: function changePassword(oldPassword, newPassword, confirmPassword) {
                var data = {
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                    confirmPassword: confirmPassword
                };
                return authenticationController.changePassword(data);
            }
        }, {
            key: "resetRecoveryCodes",
            value: function resetRecoveryCodes() {
                return authenticationController.resetRecoveryCodes();
            }
        }, {
            key: "resetAuthenticatorApp",
            value: function resetAuthenticatorApp() {
                return authenticationController.resetAuthenticatorApp();
            }
        }, {
            key: "setupAuthenticatorApp",
            value: function setupAuthenticatorApp() {
                return authenticationController.setupAuthenticatorApp();
            }
        }]);

        return AuthenticationService;
    }();

    return new AuthenticationService();
});
//# sourceMappingURL=authenticationService.js.map;
